export default `Object.defineProperty(exports, '__esModule', { value: true });`;
